import React from 'react'
import { Row, Col, Statistic, Typography, Card } from 'antd'
import { 
  NodeIndexOutlined, 
  LinkOutlined, 
  DatabaseOutlined,
  BarChartOutlined 
} from '@ant-design/icons'

const { Title } = Typography

interface KGOverviewProps {
  data: {
    node_count: number
    relation_count: number
    node_types: Array<{ type: string[]; count: number }>
    relation_types: Array<{ type: string; count: number }>
  } | null
}

const KGOverview: React.FC<KGOverviewProps> = ({ data }) => {
  if (!data) {
    return <div>加载中...</div>
  }

  return (
    <div>
      {/* 基本统计 */}
      <Row gutter={[16, 16]} style={{ marginBottom: 24 }}>
        <Col span={12}>
          <Statistic
            title="节点总数"
            value={data.node_count}
            prefix={<NodeIndexOutlined />}
            valueStyle={{ color: '#1890ff' }}
          />
        </Col>
        <Col span={12}>
          <Statistic
            title="关系总数"
            value={data.relation_count}
            prefix={<LinkOutlined />}
            valueStyle={{ color: '#52c41a' }}
          />
        </Col>
      </Row>

      {/* 节点类型分布 */}
      <Card size="small" title="节点类型分布" style={{ marginBottom: 16 }}>
        <Row gutter={[8, 8]}>
          {data.node_types.slice(0, 6).map((item, index) => (
            <Col span={12} key={index}>
              <div style={{ 
                display: 'flex', 
                justifyContent: 'space-between',
                padding: '4px 8px',
                background: '#f5f5f5',
                borderRadius: '4px',
                marginBottom: '4px'
              }}>
                <span style={{ fontSize: '12px' }}>
                  {item.type[0] || '未知类型'}
                </span>
                <span style={{ 
                  fontSize: '12px', 
                  fontWeight: 'bold',
                  color: '#1890ff'
                }}>
                  {item.count}
                </span>
              </div>
            </Col>
          ))}
        </Row>
      </Card>

      {/* 关系类型分布 */}
      <Card size="small" title="关系类型分布">
        <Row gutter={[8, 8]}>
          {data.relation_types.slice(0, 6).map((item, index) => (
            <Col span={12} key={index}>
              <div style={{ 
                display: 'flex', 
                justifyContent: 'space-between',
                padding: '4px 8px',
                background: '#f5f5f5',
                borderRadius: '4px',
                marginBottom: '4px'
              }}>
                <span style={{ fontSize: '12px' }}>
                  {item.type}
                </span>
                <span style={{ 
                  fontSize: '12px', 
                  fontWeight: 'bold',
                  color: '#52c41a'
                }}>
                  {item.count}
                </span>
              </div>
            </Col>
          ))}
        </Row>
      </Card>
    </div>
  )
}

export default KGOverview
